import React from 'react';
import PropTypes from 'prop-types';
import { useChannelSettings, useChannelStatus, useUserRole } from '../../../slice';
import { IconLock, IconTrash, IconWorld } from '../../rootAccess';
import { AlertOctogan } from '../../../assets/images';

const iconMap = {
    1: { icon: <IconWorld />, status: 'Public Channel' },
    2: { icon: <IconLock />, status: 'Private Channel' },
    3: { icon: <IconTrash />, status: 'Deleted' },
};

const statusConfig = {
    INACTIVE: { icon: <AlertOctogan />, message: 'Channel Deactivated' },
    DELETED: { icon: '', message: 'Channel has been deleted' },
};

function ChannelStatus({ channelId }) {
    const activeStatus = useChannelStatus(channelId);
    const roleId = useUserRole(channelId);
    const settings = useChannelSettings(channelId);
    const { accessMode } = settings || {};
    let icon, status, className;
    if (activeStatus === 'ACTIVE' || roleId === 0) {
        icon = iconMap[accessMode]?.icon;
        status = iconMap[accessMode]?.status;
        className = `channel-type channel-type-${status?.toLowerCase()}`;
    } else if (activeStatus === 'DELETED' && roleId !== 0) {
        status = 'Channel has been deleted';
        className = `channel-type channel-type-${activeStatus?.toLowerCase()}`;
    } else if (activeStatus === 'INACTIVE' && roleId !== 0) {
        // icon = <AlertOctogan />;
        status = 'Deactivated Channel';
        className = `channel-type channel-type-deactivated`;
    }
    return (
        <p className={className}>
            {icon}
            <span className="channel-status-text">{status}</span>
        </p>
    );
}

const Memoized = React.memo(ChannelStatus);
export { Memoized as ChannelStatus };

ChannelStatus.propTypes = {
    channelId: PropTypes.string.isRequired,
};

function ChannelActiveStatus({ channelId, className }) {
    const activeStatus = useChannelStatus(channelId);
    const settings = useChannelSettings(channelId);
    const { accessMode } = settings || {};
    if (activeStatus === 'ACTIVE') {
        return (
            <p
                className={`channel-type channel-type-${iconMap[accessMode]?.status?.toLowerCase()}`}
                style={{ justifyContent: 'center' }}
            >
                {iconMap[accessMode]?.icon}
                <span className="channel-status-text">{iconMap[accessMode]?.status}</span>
            </p>
        );
    }
    return (
        <p className={className}>
            <span className="channel-status-text">{activeStatus}</span>
        </p>
    );
}

const ChannelActive = React.memo(ChannelActiveStatus);
export { ChannelActive as ChannelActiveStatus };

ChannelActiveStatus.propTypes = {
    channelId: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const renderStatusTag = (icon, status, className = '', message = '') => (
    <div className={`privacy-status ${status?.toLowerCase()} ${className}`}>
        <div className="status-tag">
            <span className="lock-icon">{icon}</span>
            <span className="status-text">{status || message}</span>
        </div>
    </div>
);

function ChannelStatusModes({ channelId, className }) {
    const { accessMode } = useChannelSettings(channelId) || {};
    const activeStatus = useChannelStatus(channelId);

    if (statusConfig[activeStatus]) {
        const mergedClassName = `${className || ''} private`;
        return renderStatusTag(
            statusConfig[activeStatus].icon,
            '',
            mergedClassName,
            statusConfig[activeStatus].message,
        );
    }

    const { status = '', icon = null } = iconMap[accessMode] || {};
    return renderStatusTag(icon, status, className);
}

export const ChannelStatusMode = React.memo(ChannelStatusModes);

ChannelStatusModes.propTypes = {
    channelId: PropTypes.string.isRequired,
    className: PropTypes.string,
};
